export class CheckCondition {
    constructor(checkTime: string) {
        this.checkTime = checkTime;
    }
    value: string;
    checkTime: string;
    errorTips: any;
}
